export const SHOP_STATUS_OPEN_ONLINE = 'open_online'; // Client-only status
export const SHOP_STATUS_OPEN_OFFLINE = 'open_offline'; // Client-only status
export const SHOP_STATUS_CLOSED_ONLINE = 'closed_online'; // Client-only status
export const SHOP_STATUS_CLOSED_OFFLINE = 'closed_offline'; // Client-only status
export const SHOP_STATUS_CLOSED_ADHOC_ONLINE = 'adhoc_closed_online'; // Client-only status
export const SHOP_STATUS_CLOSED_ADHOC_OFFLINE = 'adhoc_closed_offline'; // Client-only status
export const TYPE_NEW_ORDER = 'newOrder';
export const TYPE_DELIVER_ORDER = 'deliverOrder';
export const TYPE_CANCEL_NEW_ORDER = 'cancelNewOrder';
export const TYPE_CANCEL_DELIVER_ORDER = 'cancelDeliverOrder';
export const TYPE_REVOKED = 'revoked';
export const STATUS_OPEN = 'open';
export const STATUS_IN_PROGRESS = 'inProgress';
export const STATUS_DONE = 'done';
export const QUEUE_INCOMING = 'incoming';
export const QUEUE_BEING_DELIVERED = 'beingDelivered';
export const QUEUE_FINALIZED = 'finalized';
export const ORDER_STATUS_ORDERED = 'ordered';
export const ORDER_STATUS_DEALER_PROCESSING = 'dealerProcessing';
export const ORDER_STATUS_DEALER_ACCEPTED = 'dealerAccepted';
export const ORDER_STATUS_DEALER_CANCELLED = 'dealerCancelled';
export const ORDER_STATUS_DEALER_DECLINED = 'dealerDeclined';
export const ORDER_STATUS_DEALER_DELIVERED = 'dealerDelivered';
export const ORDER_STATUS_CONSUMER_CANCELLED = 'consumerCancelled';
export const ORDER_STATUS_INVOICED = 'invoiced';
export const ORDER_TRANSACTIONTYPE_CHARGEBACK = 'chargeback';
export const SHOP_OPENED_MODE_DEFAULT = 'default';
export const SHOP_OPENED_MODE_ADHOC_CLOSED = 'adHocClosed';
export const SHOP_OPENED_MODE_HOLIDAY = 'holiday';
export const USER_KIND_CHAMA_USER = 'ChamaUser';
export const USER_KIND_DEALER_USER = 'DealerUser';

export default {
  TYPE_NEW_ORDER,
  TYPE_DELIVER_ORDER,
  TYPE_CANCEL_NEW_ORDER,
  TYPE_CANCEL_DELIVER_ORDER,
  TYPE_REVOKED,
  STATUS_OPEN,
  STATUS_IN_PROGRESS,
  STATUS_DONE,
  ORDER_STATUS_DEALER_CANCELLED,
  ORDER_STATUS_DEALER_DECLINED,
  QUEUE_INCOMING,
  QUEUE_BEING_DELIVERED,
  QUEUE_FINALIZED,
  USER_KIND_CHAMA_USER,
  USER_KIND_DEALER_USER,
  SHOP_STATUS_CLOSED_ADHOC_ONLINE,
  SHOP_STATUS_CLOSED_ADHOC_OFFLINE,
  SHOP_OPENED_MODE_DEFAULT,
  SHOP_OPENED_MODE_ADHOC_CLOSED,
};



// WEBPACK FOOTER //
// ../utils/constants/status.js